module.exports = __webpack_public_path__ + "favicon-16x16.png?0f06a00feb1fb12895de0d81651339b6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicons/favicon-16x16.png
// module id = 23
// module chunks = 0